var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.001,
    cy: 16,
    r: 16,
    fill: "#F5F6FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0177 8.4248C13.2594 8.4248 11.0177 10.6665 11.0177 13.4248V15.8331C11.0177 16.3415 10.801 17.1165 10.5427 17.5498L9.58438 19.1415C8.99272 20.1248 9.40105 21.2165 10.4844 21.5831C14.076 22.7831 17.951 22.7831 21.5427 21.5831C22.551 21.2498 22.9927 20.0581 22.4427 19.1415L21.4844 17.5498C21.2344 17.1165 21.0177 16.3415 21.0177 15.8331V13.4248C21.0177 10.6748 18.7677 8.4248 16.0177 8.4248Z",
    stroke: "#65717C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5594 8.66621C17.3011 8.59121 17.0344 8.53288 16.7594 8.49954C15.9594 8.39954 15.1927 8.45788 14.4761 8.66621C14.7177 8.04954 15.3177 7.61621 16.0177 7.61621C16.7177 7.61621 17.3177 8.04954 17.5594 8.66621Z",
    stroke: "#65717C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5176 21.8838C18.5176 23.2588 17.3926 24.3838 16.0176 24.3838C15.3342 24.3838 14.7009 24.1005 14.2509 23.6505C13.8009 23.2005 13.5176 22.5671 13.5176 21.8838",
    stroke: "#65717C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.63840e68c9ce7b0a2110b4088389ece3.svg";
export { ForwardRef as ReactComponent };